var map = {
	"./ali_pay.png": 9525,
	"./appa.png": 8283,
	"./ca.png": 1351,
	"./chunghwa_pay.png": 3693,
	"./credit_card_pay.png": 5252,
	"./default_pay.png": 6052,
	"./esun_pay.png": 3023,
	"./fet_pay.png": 6908,
	"./gash_pay.png": 1034,
	"./google_pay.png": 5834,
	"./gt_pay.png": 9236,
	"./kiwi.png": 8763,
	"./linepay.png": 8921,
	"./my_card.png": 3419,
	"./myfone_pay.png": 9248,
	"./paypal_pay.png": 7743,
	"./sonet_pay.png": 155,
	"./union_pay.png": 4663,
	"./visa_pay.png": 3135,
	"./wechat_pay.png": 7487,
	"./xsolla_pay.png": 5080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2638;